import { render, staticRenderFns } from "./PsychDoctorInformation.vue?vue&type=template&id=d34171d6&scoped=true&"
import script from "./PsychDoctorInformation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PsychDoctorInformation.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PsychDoctorInformation.vue?vue&type=style&index=0&id=d34171d6&lang=scss&"
import style1 from "./PsychDoctorInformation.vue?vue&type=style&index=1&id=d34171d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34171d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34171d6')) {
      api.createRecord('d34171d6', component.options)
    } else {
      api.reload('d34171d6', component.options)
    }
    module.hot.accept("./PsychDoctorInformation.vue?vue&type=template&id=d34171d6&scoped=true&", function () {
      api.rerender('d34171d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PsychDoctorInformation/PsychDoctorInformation.vue"
export default component.exports